export default {"src":"/_next/static/media/dentalOutline75_40.00e5b4e3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};